module.exports = __webpack_public_path__ + "static/media/paraty-rj.da46399f.jpg";